module.exports = __webpack_public_path__ + "img/kids-1.bcc0154d.webp";